var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGovernmentIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.245 13.389a.87.87 0 00.616-.255c.204-.204 1.996-2.055 1.996-4.098a.874.874 0 00-.48-.778L16.39 1.236a.87.87 0 00-.78 0L1.621 8.258a.875.875 0 00-.48.778c0 2.042 1.792 3.893 1.996 4.098a.881.881 0 00.616.255h.87v12.245h-.87a.87.87 0 00-.615.255c-.205.205-1.996 2.055-1.996 4.098 0 .48.39.87.87.87h27.973c.481 0 .87-.39.87-.87 0-2.043-1.79-3.893-1.995-4.098a.87.87 0 00-.616-.255h-.87V13.39h.87zM16 2.988l10.312 5.178H5.687L16 2.988zm11.863 24.387c.341.4.82 1.057 1.076 1.741H3.06c.255-.684.734-1.342 1.076-1.74h23.726zm-21.497-1.74V13.388h1.74v12.245h-1.74zm3.482 0V13.388h3.54v12.245h-3.54zm5.281 0V13.388h1.741v12.245h-1.74zm3.482 0V13.388h3.54v12.245h-3.54zm5.282 0V13.388h1.74v12.245h-1.74zM4.137 11.647c-.342-.399-.82-1.057-1.076-1.742h25.878c-.256.686-.735 1.344-1.076 1.742H4.137z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/government-industry.cb91384aa5331169ef9048a983e271f5.svg";
export { SvgGovernmentIndustry as ReactComponent };